export default "__VITE_ASSET__BR7_OW6d__"